import React, { Component } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Redirect, Link } from "react-router-dom";
import "./auth.scss";
import { Helmet } from "react-helmet";
import serviceProvider from '../../services/axios'

export class VerificationLinkSent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      msg: "",
      isLoading: false,
      redirect: false,
      isUpdate: false,
      errMsgEmail: "",
      errMsg: "",
    };
  }
  onChangehandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = {};
    data[name] = value;
    this.setState(data);
  };

  onSignInHandler = () => {
    this.setState({ isLoading: true });
    serviceProvider
      .post(
        "/user?type=forgotpassword",
        JSON.stringify({
          email: this.state.email,
        })
      )
      .then((response) => {
        this.setState({ isLoading: false });
        if (response.data.status == 200) {
          // localStorage.setItem("isLoggedIn", false);
          // this.setState({
          //msg: response.data.message,
          //redirect: true,
          // });
          this.setState({ isUpdate: true });
        }
        if (
          response.data.status == "failed" &&
          response.data.success == "undefined"
        ) {
          this.setState({
            errMsgEmail: response.data.validation_error.email,
          });
          setTimeout(() => {
            this.setState({ errMsgEmail: "" });
          }, 5000);
        } else if (
          response.data.status === "failed" &&
          response.data.success === false
        ) {
          this.setState({
            errMsg: response.data.message,
          });
          setTimeout(() => {
            this.setState({ errMsg: "" });
          }, 2000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/educate-prepare-home" />;
    }
    const login = localStorage.getItem("isLoggedIn");
    if (login) {
      return <Redirect to="/educate-prepare-home" />;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>Forgot Password | SmarterChains</title>
          <meta name="description" content="Forgot Password" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>
        <div className="auth__form--wrapp">
          {/* <Grid container> */}
          {/* left section image */}
          <Grid item xs={12} sm={4} md={4} className="auth__form--left">
            <div className="auth__form--logo">
              <img src={require("../../assets/img/auth/sc-logo.svg").default} />
            </div>
          </Grid>
          {/* right section  */}
          <Grid item xs={12} sm={8} md={8} className="auth__form--right">
            <div className="wrapper sign-in">
              {/* Start email submission msg */}
              <div className="col-6 Signup-form forgot__pass forgot__pass__msg confirm__msg0621">
                <div className="message-sent">
                  <figure>
                    <img
                      src={
                        require("../../assets/img/auth/sent-email.svg").default
                      }
                    />
                  </figure>
                  <h2>Verification link sent</h2>
                  <p>
                    We sent you a verification link to your{" "}
                    <span className="b"> email address.</span>
                    <br /> Please verify it.
                  </p>
                  <p className="mt-26">Didn’t get a verification email?</p>
                  <p>
                    Check your spam folder or{" "}
                    <Link to="" className="blue-link">
                      {" "}
                      Send again{" "}
                    </Link>
                  </p>
                </div>
              </div>
              {/* End email submission msg */}
            </div>
          </Grid>
          {/* </Grid> */}
        </div>
      </React.Fragment>
    );
  }
}
